/**
 * JSON.stringify с детерминированным порядком ключей.
 *
 * Ключ кэша React Query строится из сериализованных параметров запроса, а
 * `JSON.stringify` сохраняет порядок вставки: `{page, per_page, crm_id}` и
 * `{crm_id, per_page, page}` давали разные строки при одинаковом запросе,
 * то есть гарантированный промах кэша и лишний поход на сервер.
 * Порядок элементов массивов значим и сохраняется.
 */
export const stableStringify = (value: unknown): string =>
    JSON.stringify(value, (_key, val) => {
        if (!val || typeof val !== 'object' || Array.isArray(val)) return val;

        return Object.keys(val as Record<string, unknown>)
            .sort()
            .reduce<Record<string, unknown>>((acc, key) => {
                acc[key] = (val as Record<string, unknown>)[key];
                return acc;
            }, {});
    });
